import { Typography } from "@mui/material";

const Subscribed = () => {
  return (
    <>
      <div className="account-page_subscription-type-container">
        <Typography className="account-page_subscription-label">
          Subscription:
        </Typography>
        <Typography className="account-page_subscription-type account-page_subscription-type--friend">
          Friend ️❤️
        </Typography>
      </div>
      <Typography className="account-page_friend-label">
        {`You are a friend of Mindstack ❤️
        That means that we think you are fab.
        You have free, unlimited access to Mindstack `}
      </Typography>
    </>
  );
};

export default Subscribed;
